import { lazy } from 'react';

export const ApplicantsPage = lazy(() => import('./ApplicantsPage'));
